var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTimeCapsulesActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-time-capsules-active",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 142.753,
    height: 139.745,
    viewBox: "0 0 142.753 139.745",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_66",
    "data-name": "Rectangle 66",
    width: 142.753,
    height: 139.745,
    fill: "#1152e4"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M137.088,143.72H58.7a37.913,37.913,0,0,0,10.77-7.56l19.822-19.822a5.644,5.644,0,0,1-1.775-4.111c0-8.65-1.459-16.237-4.309-22.616A18.665,18.665,0,0,1,58.171,67.875a58.709,58.709,0,0,0-17.883-3.03,5.66,5.66,0,0,1-4.7-2.3L15.723,82.418a38.022,38.022,0,0,0,10.771,61.3H5.665a5.665,5.665,0,0,0,0,11.33H137.088a5.665,5.665,0,1,0,0-11.33",
    transform: "translate(0 -15.305)",
    fill: "#1152e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M91.322,73.018a7.346,7.346,0,1,0,7.346-7.346,7.354,7.354,0,0,0-7.346,7.346",
    transform: "translate(-22.346 -16.069)",
    fill: "#1152e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M90.73,38.274a18.662,18.662,0,0,1,15.841,28.55c.062.1.127.206.183.316a61.686,61.686,0,0,1,6.326,24.508l26.774-26.774A38,38,0,0,0,86.112,11.131L58.88,38.362a71.154,71.154,0,0,1,19.779,4.354A18.587,18.587,0,0,1,90.73,38.274",
    transform: "translate(-14.407 0)",
    fill: "#1152e4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTimeCapsulesActive);
export default __webpack_public_path__ + "static/media/icon-time-capsules-active.1b1bb2d516931f38b919e0c99d41263d.svg";
export { ForwardRef as ReactComponent };